

import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { store } from 'Store';
import { http } from 'Utils';
import { ERROR_MESSAGES, SPECIAL_CHARS_PATTERN } from 'Utils/constants';
import { setGlobalErrorStatus } from 'Components/StatusHandling';

import Col from 'react-bootstrap/Col';
import { Button, Collapse, Dropdown, Fade, ListGroup, Offcanvas} from 'react-bootstrap';
import {TextButton } from 'Components/Button';


import { useCallback, useEffect, useRef, useState } from 'react';
import { getModuleDataByDocId, getModuleDataByDocIdandCatId, getModuleDataByModuleId, getModuleDataByModuleIdandCatId } from '../Util/Utilities';
import NavigationBar from './NavigationBar';
import SearchInput from './SearchInput';
import { createPortal } from 'react-dom';
import { config } from 'Utils/config';

function SearchBar ({defaultSearchTerm,moduleCount, resultCategories, setResultCategories, resultIndex, setResultIndex, getSearchModuleData, searchTerm, setSearchTerm, itemIndexes, setItemIndexes, moduleHeaderRef,activeSearch, setActiveSearch,isSticky,focusKeywordId, setFocusKeywordId, itemListRefs, items, highlighted, comonFormatsList, setHighlighted, categoryId, moduleKey, setModuleKey,handleModuleChange, eventTypeList, handleCategoryChange}) {
   
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const [showFloatingDropdown, setShowFloatingDropdown] = useState(false);
    const [totalResults, setTotalResults] = useState(0);
    const [activeDrop, setActiveDrop] = useState(null);

    const dropdownRef = useRef(null);

    const formRef = useRef(null);
    const formStickyRef = useRef(null);

    const formBtnRef = useRef(null);
    const formStickyBtnRef = useRef(null);

    const searchDropRef = useRef(null);

    const [hasFocus, setHasFocus] = useState(false);
    const [hasBtnFocus, setHasBtnFocus] = useState(false);

    const [isFocusBase, setIsFocusBase] = useState(true);
    
    const [openBtnFocus, setOpenBtnFocus] = useState(false);
    const [searchBarFocus, setSearchBarFocus] = useState(false);
    const [searchBtnFocus, setSearchBtnFocus] = useState(false);

    const openBtnBase = useRef(null);
    const openBtn = useRef(null);

    const searchBarBase = useRef(null);
    const searchBar = useRef(null);

    const searchBarBtnBase = useRef(null);
    const searchBarBtn = useRef(null);

    const exitBtn = useRef(null);
    const floatingSearchContainerRef = useRef(null);
    
    useEffect(()=>{
        //console.log(hasFocus, formRef.current, formStickyRef.current );
        //console.log(hasBtnFocus, formBtnRef.current, formStickyBtnRef.current );

        if(formRef.current && hasFocus==true){
            (formRef.current).focus();
        }
        else if(formStickyRef.current && hasFocus==true){
            (formStickyRef.current).focus();
        }

        if(formBtnRef.current && hasBtnFocus==true){
            (formBtnRef.current).focus();
        }
        else if(formStickyBtnRef.current && hasBtnFocus==true){
            (formStickyBtnRef.current).focus();
        }
    },[formRef.current,formStickyRef.current,formBtnRef.current, formStickyBtnRef.current])
    

   
    const [mounted, setMounted] = useState(false);
   

    useEffect(() => {
        if(searchTerm!="" && activeSearch==true){
            getSearchData(searchTerm);
            //setShowFloatingDropdown(true);
            
        }
        setMounted(true);
    }, [activeSearch,defaultSearchTerm]);

    const KEY_NAME_ESC = 'Escape';
    const KEY_EVENT_TYPE = 'keydown';
    
        
    useEffect(() => {
        if(showFloatingDropdown==true){
            const modalElement = floatingSearchContainerRef.current;
            const firstElement = openBtn.current;
            const lastElement = exitBtn.current;
            const handleEscKey = (event) => {
                if (event.key === KEY_NAME_ESC) {
                    setShowFloatingDropdown(false);
                }
            };
            const handleTabKeyPress = (event) => {
                if (event.key === "Tab") {
                    if (event.shiftKey && document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    } 
                    else if (!event.shiftKey && document.activeElement === lastElement) {
                        event.preventDefault();
                        firstElement.focus();
                    }
                }
            };
            modalElement.addEventListener(KEY_EVENT_TYPE, handleTabKeyPress);
            modalElement.addEventListener(KEY_EVENT_TYPE, handleEscKey);
    
            return () => {
                modalElement.addEventListener(KEY_EVENT_TYPE, handleTabKeyPress);
                modalElement.removeEventListener(KEY_EVENT_TYPE, handleEscKey);
            };
        }
        
    }, [showFloatingDropdown, setShowFloatingDropdown]);

    useEffect(()=>{
       if(activeSearch==true){
            var currentModule = getModuleDataByDocIdandCatId(moduleKey, categoryId, resultCategories);
            
            if(currentModule!=null){
                var moduleOccurrence = currentModule?.moduleKeywordOccurrence;
                setTotalResults(moduleOccurrence);
                if(moduleOccurrence>0){
                    setResultIndex(0);
                }
                else{
                    setResultIndex(0);
                }
                setActiveDrop(categoryId + "-" + moduleKey);
                moduleHeaderRef.current.scrollIntoView();
            }
            else{
                setResultIndex(0);
                setTotalResults(0);
                setActiveDrop(null);
            }    
       }
    }, [moduleKey]);


    const getSearchData = async (keyword) => {
        var url = '/api/ag/ct/keyword';
        const loginState = store.getState().loginInfo;
        keyword=keyword.replace(SPECIAL_CHARS_PATTERN, "\\$&");

        var params = {
            keyword:keyword
        }
        const res = http.post(url, null,{
            timeout: 65000, // Set a timeout of 5 seconds,
            headers: {
                "Authorization": "Bearer " + loginState.token
            },
            params: params
        }).then((response) => {
            if(response != null ){
                var statusCode = response.status;
                if(statusCode != 1){
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true, 
                            title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                            msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length>0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                            showContactHelp: false 
                        },
                        redirect: {
                            redirect: false, 
                            redirectFirst: false,
                            path: "", 
                            data: {}
                        }
                    });
                }
                else {
                    setActiveSearch(true);

                    if(response.data.data!=null){
                        setResultCategories(response.data.data.cagetoryList);
                        var currentModule = getModuleDataByDocIdandCatId(moduleKey, categoryId, response.data.data.cagetoryList);

                        if(currentModule!=null){
                            var moduleOccurrence = currentModule?.moduleKeywordOccurrence;
                            setTotalResults(moduleOccurrence);
                            if(moduleOccurrence>0){
                                setResultIndex(0);
                                setActiveDrop(categoryId + "-" + moduleKey);
                            }
                            else{
                                setResultIndex(0);
                            }
                        }
                        else{
                            setResultIndex(0);
                            setTotalResults(0);
                        }

                        // var catList = response.data.data.cagetoryList;
                        
                        // var mods=[];
                        // var currentIndex = 1;
                        // var currentModIndex = 1;
                        
                        // for(var x = 0 ; x<catList.length ; x++){
                        //     var c = catList[x];
                            
                        //     var mList = c.moduleList;
                        //     for(var m = 0 ; m < mList.length ; m++){
                        //         var d = mList[m];
                        //         mods.push({[d.moduleName]:currentModIndex })
                        //     }
                        //     currentIndex=currentIndex + c.categoryKeywordOccurrence;
                        // }
                    }
                    else{

                    }
                    
                   
                } 
                
            }
            else{
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: true 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
            }
            setIsLoading(false);
        }).catch(function (error) {
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                },
                error: error
            });
        });
        return res;
    };

   
    

    const changeResultIndex = (change) => { 
        var index = resultIndex + change;
        config.isDebugEnabled && console.log(totalResults, "current index: " + resultIndex + " next index: " + index);

        if(totalResults>0){
            if(index > totalResults){
                index=1;
                setResultIndex(1);
            }
            else if(index < 1){
                index=totalResults;
                setResultIndex(totalResults);
            }
            else{
                setResultIndex(index);
            }
        }

        if(itemIndexes.hasOwnProperty(index-1)){
            setFocusKeywordId(itemIndexes[index-1]);
        }
    }

    useEffect(()=>{
        if((isSticky==true && activeSearch==true) || (activeSearch==true && showFloatingDropdown==true)){
            setIsFocusBase(false);
            if(openBtnFocus==true){
                if(openBtn.current){
                    (openBtn.current).focus({
                        preventScroll: true
                    });
                }
            }
            if(searchBarFocus==true){
                if(searchBar.current){
                    (searchBar.current).focus({
                        preventScroll: true
                    });
                }
            }
            if(searchBtnFocus==true){
                if(searchBarBtn.current){
                    (searchBarBtn.current).focus({
                        preventScroll: true
                    });
                }
            }
        }
        else{
            if(openBtnFocus==true){
                if(openBtnBase.current){
                    (openBtnBase.current).focus({
                        preventScroll: true
                    });
                }
            }
            if(searchBarFocus==true){
                //console.log(searchBarBase.current);
                if(searchBarBase.current){
                    (searchBarBase.current).focus({
                        preventScroll: true
                    });
                }
            }
            if(searchBtnFocus==true){
                if(searchBarBtnBase.current){
                    (searchBarBtnBase.current).focus({
                        preventScroll: true
                    });
                }
            }
        }
    },[isSticky, showFloatingDropdown, isFocusBase, openBtnFocus, searchBarFocus, searchBtnFocus, searchDropRef.current, searchBarBtn.current])

    return (
        <div  className="">                    
            <div  id="non-floating-search-container" className={ "non-floating"}>
                <Col  id="fixed-search-controls" className=" z-3  d-flex justify-content-start justify-content-md-end ">
                    <div  
                        className={"search-div-dropdown col-12 modal-open"}
                    >
                        <SearchInput
                            formRef={formRef}
                            formBtnRef={formBtnRef}
                            setShowFloatingDropdown={setShowFloatingDropdown}
                            setSearchTerm={setSearchTerm}
                            searchTerm={searchTerm}
                            getSearchData={getSearchData}
                            isSticky={isSticky}
                            hasFocus={hasFocus}
                            setHasFocus={setHasFocus}
                            hasBtnFocus={hasBtnFocus}
                            setHasBtnFocus={setHasBtnFocus}
                            itemLocation={'base'}

                            setIsFocusBase={setIsFocusBase}
                            setOpenBtnFocus={setOpenBtnFocus}
                            setSearchBarFocus={setSearchBarFocus}
                            setSearchBtnFocus={setSearchBtnFocus}
                            openBtn={openBtnBase}
                            searchBar={searchBarBase}
                            searchBtn={searchBarBtnBase}
                        >
                        </SearchInput>
                        {
                            activeSearch==true
                            ?
                                <NavigationBar
                                    setShowFloatingDropdown={setShowFloatingDropdown}
                                    showFloatingDropdown={showFloatingDropdown}
                                    resultIndex={resultIndex}
                                    totalResults={totalResults}
                                    changeResultIndex={changeResultIndex}
                                    hasFocus={hasFocus}
                                    setHasFocus={setHasFocus}
                                    hasBtnFocus={hasBtnFocus}
                                    setHasBtnFocus={setHasBtnFocus}
                                    itemLocation={'base'}
                                    setIsFocusBase={setIsFocusBase}
                                    setOpenBtnFocus={setOpenBtnFocus}
                                    setSearchBarFocus={setSearchBarFocus}
                                    setSearchBtnFocus={setSearchBtnFocus}
                                    openBtn={openBtnBase}
                                    searchBar={searchBarBase}
                                    searchBtn={searchBarBtnBase}
                                ></NavigationBar>
                            :   null
                        }
                    </div>
                </Col>              
            </div> 
            
            <div ref={floatingSearchContainerRef} id="floating-search-container" className={(isSticky==true && activeSearch==true) || (activeSearch==true && showFloatingDropdown==true)? " position-fixed top-0 start-0 w-100 " : "d-none"}>
                <Col  id="fixed-search-controls" className=" z-3  d-flex justify-content-start justify-content-md-end shadow2">
                    <Dropdown  
                        autoClose="outside"
                        show={showFloatingDropdown} 
                        ref={dropdownRef}
                        className={"search-div-dropdown col-12 modal-open"}
                    >
                        {
                            activeSearch==true
                            ?
                                <NavigationBar
                                    setShowFloatingDropdown={setShowFloatingDropdown}
                                    showFloatingDropdown={showFloatingDropdown}
                                    resultIndex={resultIndex}
                                    totalResults={totalResults}
                                    changeResultIndex={changeResultIndex}
                                    hasFocus={hasFocus}
                                    setHasFocus={setHasFocus}
                                    hasBtnFocus={hasBtnFocus}
                                    setHasBtnFocus={setHasBtnFocus}
                                    itemLocation={'fixed'}
                                    setIsFocusBase={setIsFocusBase}
                                    setOpenBtnFocus={setOpenBtnFocus}
                                    setSearchBarFocus={setSearchBarFocus}
                                    setSearchBtnFocus={setSearchBtnFocus}
                                    openBtn={openBtn}
                                    searchBar={searchBar}
                                    searchBtn={searchBarBtn}
                                ></NavigationBar>
                            :   null
                        }
                        
                        <Collapse in={showFloatingDropdown} className={" g-0 search-dropdown m-0 w-100 rounded-0 p-0 " + (isSticky==true ? " position-relative " : " position-absolute ")} align="start">
                            <div >
                                <div ref={searchDropRef} id="dropdown-search"></div>
                                <SearchInput
                                    formRef={formStickyRef}
                                    formBtnRef={formStickyBtnRef}
                                    setShowFloatingDropdown={setShowFloatingDropdown}
                                    setSearchTerm={setSearchTerm}
                                    searchTerm={searchTerm}
                                    getSearchData={getSearchData}
                                    isSticky={isSticky}
                                    hasFocus={hasFocus}
                                    setHasFocus={setHasFocus}
                                    hasBtnFocus={hasBtnFocus}
                                    setHasBtnFocus={setHasBtnFocus}
                                    itemLocation={'fixed'}
                                    setIsFocusBase={setIsFocusBase}
                                    setOpenBtnFocus={setOpenBtnFocus}
                                    setSearchBarFocus={setSearchBarFocus}
                                    setSearchBtnFocus={setSearchBtnFocus}
                                    openBtn={openBtn}
                                    searchBar={searchBar}
                                    searchBtn={searchBarBtn}
                                >
                                </SearchInput>
                                {
                                    activeSearch==true
                                    ? 
                                        <Col className="d-flex flex-column results-box ">
                                            <div className="results-container">
                                                <ListGroup className="p-0 w-100" >
                                                    { 
                                                        resultCategories != null 
                                                        ? 
                                                            <>
                                                                {
                                                                    resultCategories.length == 0 
                                                                    ?   <ListGroup.Item 
                                                                            disabled
                                                                            className="category-name body semibold color-primary-jeanblue    d-flex flex-row justify-content-between" 
                                                                            key={"none found"}
                                                                        >
                                                                            0 matches have been found.
                                                                        </ListGroup.Item>
                                                                    :   null
                                                                }
                                                                {
                                                                    resultCategories.map(c => {
                                                                        var modules = moduleCount.find((m)=>m.catId==c.categoryId);
                                                                        var m = c.moduleList[0];
                                                                        if(modules!=null && modules.count==1){
                                                                            return (
                                                                                <>
                                                                                    <ListGroup.Item 
                                                                                        as={Button}
                                                                                        action 
                                                                                        active={(c.categoryId + "-" + m.docId) === activeDrop}
                                                                                        eventKey={c.categoryId + "-" + m.docId} 
                                                                                        className="category-name body semibold color-primary-jeanblue d-flex flex-row justify-content-between" 
                                                                                        onClick={()=>{
                                                                                            if(categoryId!=c.categoryId){
                                                                                                handleCategoryChange(c.categoryId, m.docId);
                                                                                                setActiveDrop(c.categoryId + "-" + m.docId);
                                                                                                setResultIndex(0);
                                                                                                setFocusKeywordId(null);
                                                                                            }
                                                                                            else{
                                                                                                var moduleData = getModuleDataByModuleId(m.docId, eventTypeList);
                                                                                                handleModuleChange(moduleData);
                                                                                                setActiveDrop(c.categoryId + "-" + m.docId);
                                                                                                setResultIndex(0);
                                                                                                setFocusKeywordId(null);
                                                                                            }
                                                                                            setShowFloatingDropdown(false);
                                                                                        }}
                                                                                        key={"cat-"+c.categoryId + "-" + m.docId}
                                                                                    >
                                                                                        {c.categoryName} 
                                                                                        {/* <span className="count">{c.categoryKeywordOccurrence}</span> */}
                                                                                    </ListGroup.Item>
                                                                                    
                                                                                </>
                                                                            );
                                                                        }
                                                                        else{
                                                                            return (
                                                                                <>
                                                                                    <ListGroup.Item 
                                                                                        //as={Button}
                                                                                        action={false}
                                                                                        //eventKey={c.categoryId} 
                                                                                        className="category-name body semibold color-primary-jeanblue    d-flex flex-row justify-content-between" 
                                                                                        
                                                                                        key={"cat-"+c.categoryId}
                                                                                    >
                                                                                        {c.categoryName} 
                                                                                        {/* <span className="count">{c.categoryKeywordOccurrence}</span> */}
                                                                                    </ListGroup.Item>
                                                                                    {
                                                                                        c.moduleList.map(m => {
                                                                                            return (
                                                                                                <ListGroup.Item 
                                                                                                    as={Button}
                                                                                                    action 
                                                                                                    active={(c.categoryId + "-" + m.docId) === activeDrop}
                                                                                                    className="module-name     d-flex flex-row justify-content-between"
                                                                                                    eventKey={c.categoryId + "-" + m.docId} 
                                                                                                    key={"module-"+c.categoryId + "-" + m.docId}
                                                                                                    onClick={()=>{
                                                                                                        if(categoryId!=c.categoryId){
                                                                                                            setActiveDrop(c.categoryId + "-" + m.docId);
                                                                                                            handleCategoryChange(c.categoryId, m.docId);
                                                                                                            setResultIndex(0);
                                                                                                            setFocusKeywordId(null);
                                                                                                        }
                                                                                                        else{
                                                                                                            var moduleData = getModuleDataByModuleId(m.docId, eventTypeList);
                                                                                                            setActiveDrop(c.categoryId + "-" + m.docId);
                                                                                                            handleModuleChange(moduleData);
                                                                                                            setResultIndex(0);
                                                                                                            setFocusKeywordId(null);
                                                                                                        }
                                                                                                        setShowFloatingDropdown(false);
                                                                                                    }}
                                                                                                >
                                                                                                    {/* <span>{moduleBaseIndexes[m.docId]}</span> */}
                                                                                                    {m.moduleName} 
                                                                                                    {/* <span className="count">{m.moduleKeywordOccurrence}</span> */}
                                                                                                </ListGroup.Item>
                                                                                            );
                                                                                        })
                                                                                    }
                                                                                </>
                                                                            );
                                                                        }
                                                                        
                                                                    })
                                                                }
                                                            </>
                                                        :   null
                                                    }
                                                </ListGroup>
                                            </div>
                                            <div className="w-100 d-flex exit-search-container">
                                                <TextButton
                                                    ref={exitBtn}
                                                    content="Exit Search"
                                                    variant="comp-outline"
                                                    size="lg"
                                                    className="exit-search w-100 m-2 "
                                                    onClick={()=>{
                                                        setActiveSearch(false);
                                                        setShowFloatingDropdown(false);
                                                        setSearchTerm("");
                                                        setHighlighted({});
                                                        setResultIndex(0);
                                                        setFocusKeywordId(null);
                                                        setResultCategories([]);
                                                    }}
                                                ></TextButton>
                                            </div>
                                        </Col>
                                    :   null
                                }
                            </div>
                        </Collapse>
                    </Dropdown>
                </Col>              
              
                <Fade appear="false" mountOnEnter={true} unmountOnExit={true} className="offcanvas-backdrop" in={showFloatingDropdown==true } onClick={()=>{
                    setShowFloatingDropdown(false);
                }}>
                    <div></div>
                </Fade>
            </div> 
        </div>
    );
}

export default SearchBar;
